import Color from 'color';

import { isEmptyObject } from 'utils/objectManipulate';

export function getColorRGBA(color) {
    try {
        // Prevent empty string to parse
        if (!Boolean(color)) {
            return {};
        }
        const rgba = Color(color).rgb().object();
        if (rgba.alpha == null) {
            rgba.alpha = 1;
        }
        return rgba;
    } catch (error) {
        console.log(error);
        return {};
    }
}

export function convertRGBtoRGBA(color, customAlpha) {
    const colorObj = getColorRGBA(color);
    if (!isEmptyObject(colorObj)) {
        const { r, g, b, alpha = 1 } = colorObj;
        return `rgba(${r}, ${g}, ${b}, ${customAlpha || alpha})`;
    }
    return color;
}

export function adjustColorAlpha(color, transparent) {
    const colorObj = getColorRGBA(color);
    if (!isEmptyObject(colorObj)) {
        const { r, g, b, alpha = 1 } = colorObj;
        return `rgba(${r}, ${g}, ${b}, ${alpha * transparent})`;
    }
    return color;
}

export function convertRGBAtoHEX(color) {
    try {
        return Color(color).hex();
    } catch (error) {
        return color;
    }
}

export function validRGBAColor(value) {
    return /(rgb)a\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)/.test(value);
}

export function isLightColor(color) {
    const { r = 0, g = 0, b = 0 } = getColorRGBA(color);
    const sum = Math.round((parseInt(r) * 299 + parseInt(g) * 587 + parseInt(b) * 114) / 1000);
    return sum > 128;
}

export function getForegroundColor(color) {
    return isLightColor(color) ? '#000' : '#fff';
}

export function lightenDarkenColor(color, amount, type = 'light') {
    try {
        if (!color) {
            return color;
        }
        const c = Color(color);
        return type === 'light' ? c.lighten(amount).hex() : c.darken(amount).hex();
    } catch (error) {
        console.log(error);
        return color;
    }
}
